<template>
	<vx-card>
		<vs-button
			v-if="closeFormShow"
			class="float-right"
			radius
			color="primary"
			type="filled"
			icon-pack="feather"
			icon="icon-x"
			@click="returnPrevRoute"
		></vs-button>
		<div
			color="rgba(var(--vs-primary), 1)"
			title="Modification d'un client"
			subtitle="Modifiez un client et ses contacts"
			nextButtonText="Suivant"
			backButtonText="Retour"
			finishButtonText="Terminer"
		>
			<div class="mb-5">
				<!-- tab 1 content -->

				<div class="vx-row">
					<strong class="vx-col w-full mb-2 text-center"
						>Modification d'un client</strong
					>
				</div>
				<div class="vx-row mt-6">
					<!-- STATUS -->
					<div class="vx-col sm:w-1/4">
						<vx-input-group class="w-full center">
							<vs-switch v-model="society.status">
								<span slot="on">Statut Actif</span>
								<span slot="off">Statut Inactif</span>
							</vs-switch>
						</vx-input-group>
					</div>
					<!-- /STATUS -->
					<div class="vx-col w-3/4">
						<span class="float-right">* champ obligatoire</span>
					</div>
				</div>
				<div class="vx-row mt-4">
					<!-- Nom de la societé -->
					<div class="vx-col sm:w-1/3 w-full flex">
						<vx-input-group class="inlineB bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="domain" size="small"></vs-icon>*</span
									>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('name')"
									class="w-full"
									placeholder="Nom de la societé"
									v-model="society.name"
									@change="validateOne(society.name, 'name')"
								/>
								<vx-tooltip
									v-if="validators['name'] && validators['name'].errText !== ''"
									:text="errText('name')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /Nom de la societé -->
					<!-- Commercial -->
					<div class="vx-col sm:w-1/3 flex" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span>Commercial(e) *</span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									:style="styleValidator('commercial_id')"
									v-model="society.commercial_id"
									class="w-full select-medium mr-2"
									@change="validateOne(society.commercial_id, 'commercial_id')"
									autocomplete
								>
									<vs-select-item
										:key="index"
										:value="item.id"
										:text="item.firstname + ' ' + item.lastname"
										v-for="(item, index) in commercials"
										class="w-full"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['commercial_id'] &&
										validators['commercial_id'].errText !== ''
									"
									:text="errText('commercial_id')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /Commercial -->
					<!-- Client origine commerciale -->
					<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span>Origine *</span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									autocomplete
									:style="styleValidator('origin')"
									v-model="society.origin"
									class="w-full select-medium mr-2"
									@change="validateOne(society.origin, 'origin')"
								>
									<vs-select-item
										:key="index"
										:value="item.value"
										:text="item.text"
										v-for="(item, index) in originOptions"
										class="w-full"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['origin'] && validators['origin'].errText !== ''
									"
									:text="errText('origin')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /Client origine commerciale -->
				</div>
				<div class="vx-row mt-4">
					<!-- ACTIVITY_DOMAIN -->
					<div class="vx-col sm:w-1/4" style="margin-top: 1px">
						<vx-input-group class="inlineB bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="domain" size="small"></vs-icon>*</span
									>
								</div>
							</template>
							<vue-tags
								class="w-full"
								placeholder="Domaine d'activité"
								:active="society.activity_domain"
								:all="listDomaine"
								:tag-creation-enabled="true"
								tag-list-label=""
								@on-tag-added="onTagAdded($event)"
								@on-tag-removed="onTagRemoved($event)"
								@on-tag-created="onTagAdded($event)"
								@on-tag-list-opened="
									tagStyle = 'z-index: 1 !important; overflow: visible;'
								"
								@on-tag-list-closed="
									tagStyle = 'z-index: 1 !important; overflow: auto;';
									validateOne(society.activity_domain, 'activity_domain');
								"
								:style="tagStyle"
							>
							</vue-tags>
							<template slot="append">
								<vx-tooltip
									v-if="
										validators['activity_domain'] &&
										validators['activity_domain'].errText !== ''
									"
									:text="errText('activity_domain')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</template>
						</vx-input-group>
					</div>
					<!-- /ACTIVITY_DOMAIN -->
					<!-- WEBSITE -->
					<div class="vx-col sm:w-1/2 w-full flex" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="http" size="medium"></vs-icon
									></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('website')"
									v-model="society.website"
									placeholder="Site web"
									@change="validateOne(society.website, 'websiteOptional')"
								/>
								<vx-tooltip
									v-if="
										validators['websiteOptional'] &&
										validators['websiteOptional'].errText !== ''
									"
									:text="errText('websiteOptional')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /WEBSITE -->
					<!-- ISECOMMERCE -->
					<div class="vx-col sm:w-1/4 w-full" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span>Type*</span>
								</div>
							</template>
							<div style="display: flex">
								<vs-select
									autocomplete
									:style="styleValidator('is_ecommerce')"
									v-model="society.is_ecommerce"
									class="w-full select-medium"
									@change="validateOne(society.is_ecommerce, 'is_ecommerce')"
								>
									<vs-select-item
										:key="index"
										:value="item.value"
										:text="item.text"
										v-for="(item, index) in ecommerceOptions"
										class="w-full"
									/>
								</vs-select>
								<vx-tooltip
									v-if="
										validators['is_ecommerce'] &&
										validators['is_ecommerce'].errText !== ''
									"
									:text="errText('is_ecommerce')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /ISECOMMERCE -->
				</div>
				<div class="vx-row mt-4">
					<!-- ADRESSE -->
					<div class="vx-col sm:w-1/2 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="location_on" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								class="w-full"
								placeholder="Adresse"
								v-model="society.adress"
							/>
						</vx-input-group>
					</div>
					<!-- /ADRESSE -->
					<!-- COMPLEMENT D'ADRESSE -->
					<div class="vx-col sm:w-1/2 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="location_on" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								class="w-full"
								placeholder="Complément d'adresse"
								v-model="society.adress_complement"
							/>
						</vx-input-group>
					</div>
					<!-- /COMPLEMENT D'ADRESSE -->
				</div>
				<div class="vx-row mt-4">
					<!-- PAYS -->
					<div class="vx-col sm:w-2/5 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="location_on" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="society.country"
								class="w-full select-medium"
								@change="validateOne(society.country, 'country')"
							>
								<vs-select-item
									:key="index"
									:value="item.alpha2"
									:text="item.fr_fr_name"
									v-for="(item, index) in countries"
									class="w-full"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<!-- /PAYS -->
					<!-- CODE POSTAL -->
					<div class="vx-col sm:w-1/5 w-full" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"><p>CP</p></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('codePostal')"
									class="w-full"
									placeholder="Code postal"
									v-model="society.postal_code"
									@change="validateOne(society.postal_code, 'codePostal')"
								/>
								<vx-tooltip
									v-if="
										validators['codePostal'] &&
										validators['codePostal'].errText !== ''
									"
									:text="errText('codePostal')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /CODE POSTAL -->
					<!-- VILLE -->
					<div class="vx-col sm:w-2/5 w-full">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="location_city" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								class="w-full"
								placeholder="Ville"
								v-model="society.city"
							/>
						</vx-input-group>
					</div>
					<!-- /VILLE -->
				</div>
				<div class="vx-row mt-4">
					<div class="vx-col sm:w-1/4 w-full flex" style="white-space: nowrap">
						<!-- PHONE -->
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="local_phone" size="small"></vs-icon
									></span>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('phone')"
									v-model="society.phone"
									placeholder="Téléphone"
									@change="validateOne(society.phone, 'phone')"
								/>
								<vx-tooltip
									v-if="
										validators['phone'] && validators['phone'].errText !== ''
									"
									:text="errText('phone')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
						<!-- /PHONE -->
					</div>
					<!-- TVA -->
					<div class="vx-col sm:w-1/4 w-full flex">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="gavel" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								:style="styleValidator('country')"
								@change="validateOne(society.tva, 'tva')"
								v-model="society.tva"
								placeholder="TVA"
							/>
						</vx-input-group>
						<vx-tooltip
							v-if="
								validators['country'] && validators['country'].errText !== ''
							"
							:text="errText('country')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
					<div class="vx-col sm:w-1/4 w-full flex">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="gavel" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="society.tva_id"
								class="w-full select-medium"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in tva_ids"
									class="w-full"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<!-- /TVA -->
					<!-- SIRET -->
					<div class="vx-col sm:w-1/4 w-full flex" style="white-space: nowrap">
						<vx-input-group class="inlineB center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex">SIRET</span>
								</div>
							</template>
							<div style="display: flex">
								<vs-input
									:style="styleValidator('siret')"
									v-model="society.siret"
									@change="validateOne(society.siret, 'siret')"
									placeholder="000 000 000 00000"
								/>
								<vx-tooltip
									v-if="
										validators['siret'] && validators['siret'].errText !== ''
									"
									:text="errText('siret')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</div>
						</vx-input-group>
					</div>
					<!-- /SIRET -->
				</div>
				<div class="vx-row mt-4">
					<!-- SEARCH CONSOLE -->
					<div class="vx-col sm:w-1/4 w-full flex">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="show_chart" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								class="w-full"
								placeholder="Url (search console)"
								v-model="society.gsc_url"
							/>
						</vx-input-group>
						<vx-tooltip
							text="Veuillez saisir l'adresse Google Search Console associée au site du client."
						>
							<vs-avatar text="?" style="cursor: pointer"></vs-avatar>
						</vx-tooltip>
					</div>
					<!-- /SEARCH CONSOLE -->
					<!-- ANALYTICS -->
					<div class="vx-col sm:w-1/4 w-full flex">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="bar_chart" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								class="w-full"
								placeholder="View Id (analytics)"
								v-model.number="society.analytics_id"
							/>
						</vx-input-group>
						<vx-tooltip
							text="Veuillez saisir l'identifiant analytics du client."
						>
							<vs-avatar text="?" style="cursor: pointer"></vs-avatar>
						</vx-tooltip>
					</div>
					<div class="vx-col sm:w-1/4 w-full mb-6 flex">
						<vx-input-group class="w-full center">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="gavel" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-select
								autocomplete
								v-model="society.term_id"
								class="w-full select-medium"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in termsOptions"
									class="w-full"
								/>
							</vs-select>
						</vx-input-group>
					</div>
					<div class="vx-col sm:w-1/4 w-full flex">
						<vs-button @click="copyDashboardUrlToClipboard"
							>Copier l'adresse à récupérer</vs-button
						>
					</div>
					<!-- /ANALYTICS -->
				</div>
				<div class="vx-row">
					<vs-alert :active="alertBool">
						Adresse du dashboard copiée avec succès dans le presse-papier.
					</vs-alert>
				</div>
				<!-- IMAGE -->
				<div class="vx-col sm:w-1/4 w-full mt-6 mb-6">
					<vs-card style="min-width: 300px; max-width: 350px">
						<div slot="header">
							<p>Sélectionnez une image</p>
							<input
								type="file"
								name="file"
								accept="image/*"
								@change="addImagePreview($event)"
							/>
						</div>
						<div>
							<div class="vx-col w-full mt-6 mb-6" v-if="image">
								<vue-cropper
									ref="cropper"
									:src="image"
									preview=".preview"
									:cropBoxResizable="false"
									:cropBoxMovable="false"
									:minCropBoxWidth="264"
									:minCropBoxHeight="150"
									dragMode="move"
								/>
							</div>
						</div>
						<div slot="footer">
							<vs-row vs-justify="flex-end">
								<vs-button color="success" @click="imageZoom">+</vs-button>

								<vs-button color="danger" @click="imageDezoom">-</vs-button>
							</vs-row>
						</div>
					</vs-card>
				</div>
				<!-- /IMAGE -->
			</div>

			<!-- CONTROL UI FOOTER BUTTON -->
			<div class="float-right mb-5">
				<vs-button @click="updateSociety">Enregistrer</vs-button>
			</div>
		</div>
	</vx-card>
</template>

<script>
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import validatorMixin from "@/mixins/validatorMixin";
import Validator from "@/entities/Validator";
import { Society } from "@/entities/Society";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import ContactForSociety from "../contact/ContactForSociety";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

// Import FilePond
import vueFilePond from "vue-filepond";

// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";
import { VueTags } from "vue-tags-component";

// Import styles
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// Create FilePond component
const FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview
);

export default {
	name: "UpdateSocietyForm",
	mixins: [utilsMixin, dbFieldConvertor, validatorMixin],
	components: {
		VueCropper,
		VxTooltip,
		VueTags,
	},
	data() {
		return {
			closeFormShow: true,
			// Society OBJECT,
			society: Society.getFormFields(),
			societyOld: Society.getFormFields(),
			societyContact: [],
			contactAdded: 0,
			clickAddContact: true,
			apiUrl: this.$store.state.backendApiUrl,
			commercials: null,
			alertBool: false,

			// Validator Objects
			ClientValidationObjects: {
				nameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "nameConstraint",
					required: true,
				},
				siretValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "siretConstraint",
					required: false,
				},
				commercial_idValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "commercial_idConstraint",
					required: true,
				},
				originValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "originConstraint",
					required: true,
				},
				websiteValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true,
				},
				is_ecommerceValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "is_ecommerceConstraint",
					required: true,
				},
				statusValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "statusConstraint",
					required: false,
				},
			},

			// FORM SELECT OPTIONS
			originOptions: [
				{ text: "Agence", value: 1 },
				{ text: "Salon", value: 2 },
				{ text: "Prospection", value: 3 },
				{ text: "Appel Entrant", value: 4 },
				{ text: "Réseau", value: 5 },
				{ text: "Lead entrant", value: 6 },
				{ text: "Apporteur d'affaire", value: 7 },
				{ text: "Événements", value: 8 },
			],
			ecommerceOptions: [
				{ text: "E-commerce", value: 1 },
				{ text: "Vitrine", value: 0 },
			],
			image: null,
			validators: {},
			check: true,

			//Tags
			listDomaine: [],
			tagStyle: "z-index: 1 !important; overflow: auto;",
		};
	},

	async created() {
		this.getAllTvaIds();
		this.$store.dispatch("getAllCountries");
		this.$store.dispatch("getAllTerms");
		let society = await this.$http.get(
			this.apiUrl + "society/get/" + this.$route.params.societyId
		);
		this.society = new Society(society.data);
		this.societyOld = new Society(society.data);
		let country = this.countries.filter(
			(country) =>
				String(country.fr_fr_name).toLowerCase() ==
				String(this.society.country).toLowerCase()
		);
		if (country.length > 0) {
			this.societyOld.country = country[0].alpha2;
			this.society.country = country[0].alpha2;
		}

		//console.log("society", this.society);
		if (this.society.img_link) {
			//console.log("society.img_link", this.society.img_link);
			this.getSocietyImage(this.$route.params.societyId);
		}
		await this.getActivityDomain();
		this.getCommercials();
		this.getDomain();
	},
	computed: {
		countries: function () {
			return store.state.countries;
		},
		termsOptions: function () {
			return store.state.terms;
		},
		tva_ids: function () {
			return store.state.tva_ids;
		},
	},
	watch: {
		contactAdded: function () {
			//console.log("contactAdded called");
			// Fetch contact linked to the society
			this.getSocietyContact();
		},
	},
	methods: {
		getAllTvaIds() {
			this.$store.dispatch("getAllTvaIds");
		},

		onTagAdded(tag) {
			if (this.society.activity_domain.indexOf(tag) < 0)
				this.society.activity_domain.push(tag);
		},

		onTagRemoved(tag) {
			this.society.activity_domain.splice(
				this.society.activity_domain.indexOf(tag),
				1
			);
		},

		copyDashboardUrlToClipboard() {
			// A IMPLEMENTER ET TESTER
			// Url.text = "dashboard-service-account@dashboard-1603872171362.iam.gserviceaccount.com";
			const el = document.createElement("textarea");
			el.value =
				"dashboard-service-account@dashboard-1603872171362.iam.gserviceaccount.com";
			el.setAttribute("readonly", "");
			el.style.position = "absolute";
			el.style.left = "-9999px";
			document.body.appendChild(el);
			const selected =
				document.getSelection().rangeCount > 0
					? document.getSelection().getRangeAt(0)
					: false;
			el.select();
			document.execCommand("copy");
			document.body.removeChild(el);
			if (selected) {
				document.getSelection().removeAllRanges();
				document.getSelection().addRange(selected);
			}
			this.alertBool = true;
			setTimeout(() => {
				this.alertBool = false;
			}, 2000);
		},

		validateOne(val, name) {
			let value = val;
			value == 0 && name !== "siret" ? (value = "0") : "";

			if (name == "tva" && val && this.validators["country"].errText)
				this.validators["country"].errText = "";
			name == "codePostal" ? (value = String(val)) : "";

			let constname = name + "Constraint";

			if (name == "activity_domain") {
				constname = "statusConstraint";
				value = this.society.activity_domain.length;
			}

			if (name == "country" || name == "tva") {
				constname = "nameConstraint";
				if (this.society.country == "FR") this.society.tva_id = 1;
			}

			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			if (
				this.validators[name].valid == false &&
				this.validators[name].errText == ""
			) {
				if (
					name == "name" ||
					name == "origin" ||
					name == "commercial_id" ||
					name == "is_ecommerce"
				) {
					this.validators[name].errText = "Ce champ ne peut être vide.";
				}
				if (name == "activity_domain" && value == 0)
					this.validators[name].errText = "Ce champ ne peut être vide.";
				if (name == "activity_domain" && value > 0)
					this.validators[name].errText = "";
			}
			if (
				name == "country" &&
				this.countries.filter(
					(country) => country.tva_required == 1 && country.alpha2 == value
				).length > 0 &&
				!this.society.tva
			)
				this.validators[name].errText = "Ce champ ne peut être vide.";
			if (
				name == "country" &&
				this.countries.filter(
					(country) => country.tva_required == 1 && country.alpha2 == value
				).length == 0
			)
				this.validators[name].errText = "";

			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return "display: inline-block; width: auto !important; border: 1px solid red !important; border-radius: 0 5px 5px 0;";
			} else if (this.validators[name] && this.validators[name].errText == "") {
				return "display: inline-block; width: auto !important; border: 1px solid green !important; border-radius: 0 5px 5px 0;";
			} else {
				return "display: inline-block; border: none !important; border-radius: none;";
			}
		},
		/**
		 * Send the data to tha API to create the new society
		 * If the form is successfully sent, the society is redirect to Client.vue
		 */
		updateSociety() {
			this.check = true;
			let fields = [
				"name",
				"activity_domain",
				"origin",
				"websiteOptional",
				"commercial_id",
				"is_ecommerce",
				"codePostal",
				"isNumber",
				"siret",
				"phone",
				"country",
				"tva",
			];

			for (let i = 0; i < fields.length; i++) {
				let name = fields[i] + "Constraint";
				let value = this.society[fields[i]];

				value == 0 && fields[i] !== "siret" ? (value = "0") : "";

				if (fields[i] == "tva" && value && this.validators["country"].errText)
					this.validators["country"].errText = "";
				if (fields[i] == "codePostal") value = String(this.society.postal_code);

				if (fields[i] == "activity_domain") {
					name = "statusConstraint";
					value = this.society.activity_domain.length;
				}
				if (fields[i] == "country" || fields[i] == "tva") {
					name = "nameConstraint";
					if (this.society.country == "FR") this.society.tva_id = 1;
				}

				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);

				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				) {
					if (
						fields[i] == "name" ||
						fields[i] == "activity_domain" ||
						fields[i] == "origin" ||
						fields[i] == "commercial_id" ||
						fields[i] == "is_ecommerce"
					) {
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					}
					if (fields[i] == "activity_domain" && value == 0)
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					if (fields[i] == "activity_domain" && value > 0)
						this.validators[fields[i]].errText = "";
				}
				if (
					fields[i] == "country" &&
					this.countries.filter(
						(country) => country.tva_required == 1 && country.alpha2 == value
					).length > 0 &&
					!this.society.tva
				) {
					this.validators[fields[i]].valid = false;
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
				}
				if (
					fields[i] == "country" &&
					this.countries.filter(
						(country) => country.tva_required == 1 && country.alpha2 == value
					).length == 0
				) {
					this.validators[fields[i]].valid = true;
					this.validators[fields[i]].errText = "";
				}

				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
				this.$forceUpdate();
			}
			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
			} else {
				this.$vs.notify({
					title: "En cours...",
					text: "La mise à jour du client est en cours.",
				});
				// Modified Society Object
				if (this.society.siret)
					this.society.siret = this.transformSiretDbFormat(this.society.siret);
				this.society.website = this.society.website;
				if (this.society.postal_code)
					this.society.postal_code = this.removeSpace(this.society.postal_code);
				let status = false;
				if (this.society.status) {
					status = true;
				}
				this.society.status = status;

				// Old Society Object
				if (this.societyOld.siret)
					this.societyOld.siret = this.transformSiretDbFormat(
						this.societyOld.siret
					);
				this.societyOld.website = this.societyOld.website;
				if (this.societyOld.postal_code)
					this.societyOld.postal_code = this.removeSpace(
						this.societyOld.postal_code
					);
				let statusOld = false;
				if (this.societyOld.status) {
					statusOld = true;
				}
				this.societyOld.status = statusOld;

				//Compare modified society with original one then update if different
				if (!this.society.compare(this.societyOld)) {
					//Formating object for update
					this.society.id = this.$route.params.societyId; //Adding ID
					this.society.creation_timestamp =
						this.society.creation_timestamp.replace("T", " ");
					this.society.creation_timestamp =
						this.society.creation_timestamp.replace("Z", "");
					this.society.last_update_timestamp =
						this.society.last_update_timestamp.replace("T", " ");
					this.society.last_update_timestamp =
						this.society.last_update_timestamp.replace("Z", "");
					this.society.country_id = this.countries.filter(
						(country) => country.alpha2 == this.society.country
					)[0].id;
					this.society.country = this.countries.filter(
						(country) => country.alpha2 == this.society.country
					)[0].fr_fr_name;

					this.society.update(this.society.id, (err, res) => {
						if (err) {
							//console.log(err);
							// Send a failure notification to the user
							this.$vs.notify({
								title: "Echec",
								text: "Une erreur est survenue.",
							});
						}
						if (res) {
							//If there if something in the image input field, Update Image
							if (this.image) {
								// this.addImageToPost()
								this.$refs.cropper
									.getCroppedCanvas({ width: 264, height: 150 })
									.toBlob((blob) => {
										//console.log("cropping", blob);
										let formData = new FormData();
										formData.append("image", blob, "society.png");
										this.society.image = formData;
										//console.log("Formdata: ", formData);
										this.$http
											.post(
												this.apiUrl +
													"society/updateImage/" +
													this.$route.params.societyId,
												formData,
												{
													headers: {
														accept: "application/json",
														"Accept-Language": "en-US,en;q=0.8",
														"Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
													},
												}
											)
											.then(() => {
												this.$vs.notify({
													title: "Succès",
													text: "Image du client modifée avec succès.",
												});
											})
											.catch((err) => {
												this.$vs.notify({
													title: "Echec",
													text: "L'image du client n'a pas été modifée.",
												});
											});
									});
							} else {
								this.$vs.notify({
									title: "Succès",
									text: "Client modifié avec succès.",
								});
							}
							// Send a success notification to the user
							this.$store.dispatch("getAllSocieties");
							this.returnPrevRoute();
						}
					});
				} else if (this.image) {
					// this.addImageToPost()
					this.$refs.cropper
						.getCroppedCanvas({ width: 264, height: 150 })
						.toBlob((blob) => {
							//console.log("cropping", blob);
							let formData = new FormData();
							formData.append("image", blob, "society.png");
							this.society.image = formData;
							//console.log("Formdata: ", formData);
							this.$http
								.post(
									this.apiUrl +
										"society/updateImage/" +
										this.$route.params.societyId,
									formData,
									{
										headers: {
											accept: "application/json",
											"Accept-Language": "en-US,en;q=0.8",
											"Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
										},
									}
								)
								.then(() => {
									this.$vs.notify({
										title: "Succès",
										text: "Image du client modifée avec succès.",
									});
									this.$store.dispatch("getAllSocieties");
									this.returnPrevRoute();
								})
								.catch((err) => {
									this.$vs.notify({
										title: "Echec",
										text: "L'image du client n'a pas été modifée.",
									});
								});
						});
				} else {
					this.$vs.notify({
						title: "Aucune modification",
						text: "Le client n'a pas été modifié.",
					});
				}
			}
		},

		getCommercials() {
			this.$http
				.get(this.apiUrl + "users/all/rankwell")
				.then((fetchedRankwell) => {
					this.commercials = this.sortABC(
						fetchedRankwell.data.filter((collaborator) =>
							[4, 6, 9].includes(collaborator.type)
						),
						"firstname"
					);
				})
				.catch((err) => {
					console.error(err);
				});
			/*
			 * Collaborator.getCommercials((err, res) => {
			 *   this.commercials = res;
			 * });
			 */
		},

		/**
		 * Get the ID for the newly created society to associate it with contacts
		 */
		getSocietyId() {
			this.$http
				.get(this.apiUrl + "society/getId/" + this.society.name)
				.then((res) => {
					this.society.id = res.data.id;
				})
				.catch((err) => console.log(err));
		},

		getDomain() {
			this.$http
				.get(this.apiUrl + "tags/all")
				.then((res) => {
					let tmp = res.data;
					for (let tag of tmp) {
						tag["name"] = tag.tag_name;
						tag["slug"] = tag.tag_name;
						delete tag.tag_name;
					}
					this.listDomaine = tmp;
				})
				.catch((err) => console.log(err));
		},

		getActivityDomain() {
			this.$http
				.get(this.apiUrl + "tags/society/" + this.$route.params.societyId)
				.then((res) => {
					let tmp = res.data;
					//console.log("getActivityDomain", tmp);
					for (let tag of tmp) {
						tag["name"] = tag.tag_name;
						tag["slug"] = tag.tag_name;
						delete tag.tag_name;
					}
					//console.log("getActivityDomain 2", tmp);
					this.society.activity_domain = tmp || [];
				})
				.catch((err) => console.log(err));
		},

		/**
		 * Fetch all contact corresponding to a society from our API
		 */
		getSocietyContact() {
			// this.getSocietyId();
			this.$http
				.get(this.apiUrl + "society/getId/" + this.society.name)
				.then((res) => {
					this.society.id = res.data.id;
				})
				.then(() => {
					this.$http
						.get(this.apiUrl + "users/getuserforsociety/" + this.society.id)
						.then((res) => {
							this.societyContact = res.data;
							//console.log("getSocietyContact");
						});
				})
				.catch((err) => console.log(err));
		},

		showContactForm() {
			this.clickAddContact = true;
		},

		closeContactForm(value) {
			this.clickAddContact = value;
		},

		refreshData(value) {
			this.contactAdded += value;
			this.clickAddContact = false; // Close the form
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},

		addImagePreview(e) {
			// URL.revokeObjectURL(this.image);
			//console.log("addImagePreview", this.$refs.cropper);
			this.image = URL.createObjectURL(e.target.files[0]);
			this.$refs.cropper.replace(this.image);
			this.$refs.cropper.minCropBoxWidth(264);
			this.$refs.cropper.minCropBoxHeight(150);
			this.$refs.cropper.setCropBoxData({ width: 264, height: 150 });
		},

		addImageToPost() {
			this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
				//console.log("cropping", blob);
				let formData = new FormData();
				formData.append("image", blob, "society.png");
				this.society.image = formData;
			});
		},

		imageZoom() {
			this.$refs.cropper.relativeZoom(0.1);
		},

		imageDezoom() {
			this.$refs.cropper.relativeZoom(-0.1);
		},

		/**
		 * Fetch image if society.image is true else return false
		 * @param {Society} society - The society from which image is requested
		 */
		getSocietyImage(society) {
			this.$http
				.get(this.apiUrl + "society/getImg/" + society)
				.then((image) => {
					this.image = image.data;
				})
				.catch((err) => {
					//console.log(err);
				});
		},
	},
};
</script>

<style>
.center_div {
	justify-content: center;
}
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.table_sizing {
	max-width: 600px;
}

.bottom {
	align-self: flex-end;
}
.center {
	align-self: center;
}
.wizard-progress-bar {
	display: none;
}
.domain {
	position: absolute;
	z-index: 1;
	background: white;
	margin-left: 50px;
	border: 1px solid grey;
	padding: 5px;
}
.domain-line:hover {
	cursor: pointer;
}
.noBorder {
	border: none;
}
.inlineB {
	width: calc(100% - 30px) !important;
}
.vx-input-group-default.flex-grow {
	width: inherit;
}
input::placeholder {
	font-family: "Montserrat", Helvetica, Arial, sans-serif;
	font-weight: 400;
	color: black;
	padding: 0.2rem !important;
	font-size: 0.85rem;
}
</style>
